const Paths = {
  Home: '/',
  Login: '/login',
  DealerPortal: '/dealer-portal',
  ConfirmAccount: '/confirm-account/:confirmToken',
};

export default Paths;
